import { create } from "zustand";

export enum ResolutionType {
  HD = 1,
  FULL_HD,
}

export enum OrientationType {
  PORTRAIT = 1,
  LANDSCAPE,
}

export type ScreenStore = {
  resolution: ResolutionType;
  orientation: OrientationType;
};

export const useScreenStore = create<ScreenStore>((set) => {
  const updateResolution = () => {
    const newResolution =
      Math.max(window.innerWidth, window.innerHeight) >= 1920
        ? ResolutionType.FULL_HD
        : ResolutionType.HD;
    const newOrientation =
      window.innerWidth > window.innerHeight
        ? OrientationType.LANDSCAPE
        : OrientationType.PORTRAIT;
    set({ resolution: newResolution, orientation: newOrientation });
  };

  updateResolution();

  window.addEventListener("resize", updateResolution);
  window.addEventListener("orientationchange", updateResolution);

  return {
    resolution:
      Math.max(window.innerWidth, window.innerHeight) >= 1920
        ? ResolutionType.FULL_HD
        : ResolutionType.HD,
    orientation:
      window.innerWidth > window.innerHeight
        ? OrientationType.LANDSCAPE
        : OrientationType.PORTRAIT,
  };
});
